import React from 'react';
import styled from 'styled-components';
import { Container, Media } from '../../components';
import { MeetTheTeamDesktop } from './desktop';
import { MeetTheTeamMobile } from './mobile';
import { MeetTheTeamTablet } from './tablet';

const DesktopWrapper = styled.section`
  background-color: #fff;
`;

export const MeetTheTeam = () => {
  // Hiding this module at present
  return null;
  return (
    <>
      <Container>
        <Media at="sm">
          <MeetTheTeamMobile />
        </Media>
      </Container>
      <Container>
        <Media at="md">
          <MeetTheTeamTablet />
        </Media>
      </Container>
      <DesktopWrapper>
        <Container>
          <Media greaterThanOrEqual="xmd">
            <MeetTheTeamDesktop />
          </Media>
        </Container>
      </DesktopWrapper>
    </>
  );
};
